export const gift = {
  selectGift: "ギフトを選択",
  gift: "ギフト",
  giftCategory: (args: { number: string | number }) =>
    `ギフトカテゴリ${args.number}`,
  giftItem: (args: { number: string | number }) => `ギフト${args.number}`,
  sendGiftTitle: "ギフトメニュー",
  giftPromptTitle: "ギフトであなたを覚えてもらおう",
  giftPromptBody: "まだドキドキしているうちに。",
  giftPromptOpen: "ギフトを選ぶ",
  giftPromptLater: "あとで",
  holdToSend: "長押しで贈る",
  sendingGift: "贈っています…",
  holdToSendHint: "ボタンを長押しすると贈れます",
  giftSent: "ギフトを贈りました！",
  giftInsufficient: (args: { point: string | number }) =>
    `ポイントが足りません（あと ${args.point}pt）`,
  chargePoint: "ポイントをチャージする",
  giftRecipient: (args: { name: string | number }) => `${args.name} へ`,
  prevGift: "前のギフト",
  nextGift: "次のギフト",
  goToGift: (args: { number: string | number }) =>
    `${args.number}番目のギフトを表示`,
  giftInsufficientToast: "ポイントが足りません",
  giftConditionTitle: "ギフト機能解放条件",
  giftConditionMessage: "1回以上ポイント購入をする",
  checkingGiftAccess: "ギフト利用可否を確認中",
} as const;
